import React, { type FC, createContext, type Dispatch, useContext } from 'react'
import { useImmerReducer } from 'use-immer'
import { noop } from 'helpers/utils'

import { type ReducerAction, type BaseProps } from 'types'
import appReducer, { type State, type AppActionPayload } from 'reducers/app'
import { CONTACT_PERMISSION_KEY } from 'constants.app'

const initialAppState: State = {
  trackingInfo: {
    contactPermissionGranted: JSON.parse(
      window.localStorage.getItem(CONTACT_PERMISSION_KEY) ?? 'false',
    ),
  },
  canShowChangeNumber: false,
  isRecharge: false,
}
const dummyDispatch: Dispatch<ReducerAction<AppActionPayload>> = noop

export const AppStateContext = createContext<State>(initialAppState)
const AppDispatchContext = createContext<Dispatch<ReducerAction<AppActionPayload>>>(dummyDispatch)

const AppProvider: FC<BaseProps> = ({ children }) => {
  const [appState, dispatch] = useImmerReducer(appReducer, initialAppState)

  return (
    <AppStateContext.Provider value={appState}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppStateContext.Provider>
  )
}

export const useAppState = (): State => {
  return useContext(AppStateContext)
}

export const useAppDispatch = (): Dispatch<ReducerAction<AppActionPayload>> => {
  return useContext(AppDispatchContext)
}

export default AppProvider
